import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdate() {
  const comics = getLatestComics();

  return (
    <section className="py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-1">最新更新</h2>
            <p className="text-sm text-foreground-500">第一时间获取最新漫画章节</p>
          </div>
          <Link to="/category/all" className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="space-y-3">
          {comics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/10 transition-all duration-300 cursor-pointer group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${index < 3 ? 'bg-primary-500 text-white' : 'bg-secondary-200 text-secondary-700'}`}>
                {index + 1}
              </span>
              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">{comic.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <span className={`inline-block px-2 py-0.5 text-xs rounded-md ${comic.status === '已完结' ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-700'}`}>
                  {comic.status}
                </span>
                <p className="text-xs text-foreground-500 mt-1">更新至 {comic.chapters} 话</p>
              </div>
              <div className="hidden md:block flex-shrink-0 text-xs text-foreground-400">
                {comic.updatedAt}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}